import { __SOURCE_ILT__PLAN_VS_TARGET } from '../commom'
import { openModal } from '../../CommentsModal'

try {
    if (!window.ilt) {
        window['ilt'] = {}
    }

    window['ilt']['openILTPlanVSTargetEditionAnnotation'] = event => {
        openModal(event)
    }
} catch (e) {
    console.error(e)
}
